import script from "./AppButtonFlat.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppButtonFlat.vue?vue&type=script&setup=true&lang=ts"

import "./AppButtonFlat.vue?vue&type=style&index=0&id=9e64ba34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e64ba34"]])

export default __exports__